import { styled } from '@mui/material/styles';

export const StyledDiv = styled('div')`
  > div {
    cursor: pointer!important;
  }
`;
